import { PrescriptionType } from '../../../../../models/line-item/prescription-glasses.js';
import { getLensDetails } from '../../../../../utils/get-lens-details.js';

function getPrescription(typeDetails) {
    if (typeDetails.isExistingCustomer) {
        return {
            type: PrescriptionType.EXISTING_CUSTOMER
        };
    }
    if (typeDetails.newPrescription && typeDetails.prescriptionFile && typeDetails.pupillaryDistanceFile) {
        return {
            type: PrescriptionType.OCR_PRESCRIPTION,
            rightLens: getLensDetails(typeDetails.newPrescription.rightLens),
            leftLens: getLensDetails(typeDetails.newPrescription.leftLens),
            prescriptionFile: typeDetails.prescriptionFile.fileName,
            pupillaryDistanceFile: typeDetails.pupillaryDistanceFile.fileName
        };
    }
    if (typeDetails.newPrescription) {
        return {
            type: PrescriptionType.NEW_PRESCRIPTION,
            rightLens: getLensDetails(typeDetails.newPrescription.rightLens),
            leftLens: getLensDetails(typeDetails.newPrescription.leftLens)
        };
    }
    if (typeDetails.prescriptionFile && typeDetails.pupillaryDistanceFile) {
        return {
            type: PrescriptionType.PRESCRIPTION_FILE,
            prescriptionFile: typeDetails.prescriptionFile.fileName,
            pupillaryDistanceFile: typeDetails.pupillaryDistanceFile.fileName
        };
    }
    return {
        type: PrescriptionType.EMAIL_PRESCRIPTION
    };
}

export { getPrescription };
//# sourceMappingURL=get-prescription.js.map
